import React, { FC } from 'react';

import { I18n } from '@utils/index';
import { GoBack } from '@widget/airdrop/components/GoBack';

import styles from './index.module.less';

export const HistoryBanner: FC = () => {
  return (
    <div className={styles.container}>
      <GoBack />
      <div className={styles.title}>{I18n.t('pQgwmvRc')}</div>
    </div>
  );
};
